<template>
  <v-container fluid grid-list-md class="pa-0">
    <v-layout row wrap>
      <v-flex sm3>
        <v-text-field
          label="Supplier Name"
          v-model="payment.supplierName"
          @input="onChange(payment)"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex sm3>
        <v-text-field
          label="Iti Reference"
          v-model="payment.itineraryReference"
          readonly
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex sm3>
        <currency-list-select
          :enabled="false"
          v-model="payment.currencyCode"
          :outlined="outlinedInputs"
          includeExchangeRate
          @onSelect="onSelectCurrency"
        ></currency-list-select>
      </v-flex>
      <v-flex sm3>
        <v-text-field
          label="Amount"
          type="number"
          v-model.number="payment.amount"
          @input="onChange(payment)"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex sm6>
        <taxes-list-select
          :tax-code="payment.vatCode"
          @onSelectTaxType="
            onChange(Object.assign({}, payment, { vatCode: $event.code }))
          "
          :do-reset-selected-tax="!paymentDialog"
          :outlined="outlinedInputs"
        ></taxes-list-select>
      </v-flex>
      <v-flex>
        <payment-type-select
          v-model="payment.type"
          @input="onChange(payment)"
          :outlined="outlinedInputs"
        ></payment-type-select>
      </v-flex>
      <v-flex v-if="showPaymentMethods"
        ><payment-method-list-select
          v-model="payment.paymentMethodId"
          @input="onChange(payment)"
          :outlined="outlinedInputs"
        ></payment-method-list-select
      ></v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm2>
        <date-picker
          :gt-date-string="payment.paymentDate"
          :reset-date="!paymentDialog"
          v-model="payment.paymentDate"
          customLabel="Payment Date"
          :outlined="outlinedInputs"
          @onDateSelected="onPaymentDateSelected"
        ></date-picker>
      </v-flex>

      <v-flex sm7>
        <v-text-field
          label="Payment Ref"
          v-model="payment.reference"
          @input="onChange(payment)"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex sm3>
        <v-text-field
          v-model.number="payment.exchangeRate"
          type="number"
          label="Exchange Rate"
          @input="onChange(payment)"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm12>
        <v-textarea
          v-model="payment.notes"
          label="Notes"
          @input="onChange(payment)"
          :outlined="outlinedInputs"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-row v-if="showExported">
      <v-col class="py-0">
        <v-checkbox
          v-model="payment.exported"
          label="Exported"
          class="my-0"
          hide-details
          @change="onChange(payment)"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <code>{{ payment }}</code>
    </v-row>
  </v-container>
</template>

<script>
import PaymentTypeSelect from "../../../gt/shared/PaymentTypeSelect";
import DatePicker from "../../../gt/shared/DatePicker";
import TaxesListSelect from "../../../gt/shared/TaxesListSelect";
import CurrencyListSelect from "../../../gt/shared/CurrencyListSelect";
import PaymentMethodListSelect from "../../../gt/shared/PaymentMethodListSelect.vue";
export default {
  name: "PurchaseInvoicePaymentDetailsEditor",

  components: {
    TaxesListSelect,
    CurrencyListSelect,
    PaymentTypeSelect,
    DatePicker,
    PaymentMethodListSelect,
  },

  props: {
    purchaseInvoicePayment: {
      type: Object,
      default: () => {},
    },
    paymentDialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      debug: false,
      payment: {
        vatCode: this.purchaseInvoicePayment.taxCode,
        paymentDate: new Date().toUTCString(),
        type: this.purchaseInvoicePayment.paymentType,
        ...this.purchaseInvoicePayment,
      },
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    showExported() {
      return this.$store.getters.hasAccessTo("finances:unexport");
    },
    showPaymentMethods() {
      return this.$store.getters.hasAccessTo("finances:payment_methods");
    },
  },

  methods: {
    onSelectCurrency(currency) {
      //only update exchange rate if it is not already set
      if (!this.payment.exchangeRate) {
        this.payment.exchangeRate = currency.exchangeRate;
      }
      this.onChange(this.payment);
    },
    onChange(payment) {
      this.$emit("onChange", {
        ...this.payment,
        amount: Number(payment.amount),
      });
    },
    onPaymentDateSelected(date) {
      this.payment.paymentDate = date;
      this.onChange(this.payment);
    },
  },

  watch: {
    purchaseInvoicePayment(data) {
      this.payment = {
        type: data.paymentType,
        vatCode: data.taxCode,
        ...data,
      };
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/finances/purchase-invoice-payments/PurchaseInvoicePaymentDetailsEditor.vue